import React from "react";

const Contactus = () => {
    return(
        <div>
           <header className>
        <nav className="navbar navbar-expand-lg">
          <div className="container">
          <img src="assets/images/la-logo-240px.png" className="la-logo" alt=""></img>
            <a className="navbar-brand" href="index.html"><h2>Lakshan Associates</h2></a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarResponsive">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <a className="nav-link" href="/home">Home
                    <span className="sr-only"></span>
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/about">About Us</a>
                </li>
                <li className="nav-item ">
                  <a className="nav-link" href="/ourservices">Our Services</a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="/ourfacilities">Our Facilities</a>
                </li>
                <li className="nav-item active">
                  <a className="nav-link" href="/contactus">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
        {/* Page Content */}
        <div className="page-heading header-text">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h1>Contact Us</h1>
                <span>feel free to send us a message now!</span>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-information">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="contact-item">
                  <i className="fa fa-phone" />
                  <h4>Phone</h4>
                  <p>Let's talk about your requirement!</p>
                  <a href="tel:+91-8939897239">+91-8939897239</a>&nbsp;|&nbsp;<a href="tel:+91-8939897239">+91-7299947239</a>
                </div>
              </div>
              <div className="col-md-6">
                <div className="contact-item">
                  <i className="fa fa-envelope" />
                  <h4>Email</h4>
                  <p>Send us a message and we will be in touch within one business day.</p>
                  <a href="mailto:lakshanassociates@gmail.com">lakshanassociates@gmail.com</a>
                </div>
              </div>
            </div>
            <div className="row pt-4">
              <div className="col-md-4">
                <div className="contact-item">
                  <i className="fa fa-map-marker" />
                  <h4>Registered Office</h4>
                  <p>No.39 Panchayat Road, Mambakkam Village &amp; Post, Sriperumbudur Taluk, Kanchipuram District, Pincode-602106.</p>
                  <a href="https://goo.gl/maps/nWW4cMigferPk9Ei8">View on Google Maps</a>
                </div>
              </div>
              <div className="col-md-4">
                <div className="contact-item">
                  <i className="fa fa-map-marker" />
                  <h4>Registered Factory</h4>
                  <p>SF.NO 52/3E, Opposite SIPCOT Road, Mambakkam Village &amp; Post, Sriperumbudur Taluk, Kanchipuram District, Pincode-602106.</p>
                  <a href="https://goo.gl/maps/nWW4cMigferPk9Ei8">View on Google Maps</a>
                </div>
              </div>
              <div className="col-md-4">
                <div className="contact-item">
                  <i className="fa fa-map-marker" />
                  <h4>Registered Godown</h4>
                  <p>Plot No 1,2,25, 26, Sri Ambal Nagar, Santhevellore Village &amp; Post, Sriperumbudur Taluk, Kanchipuram District, Pincode-602105.</p>
                  <a href="https://goo.gl/maps/nWW4cMigferPk9Ei8">View on Google Maps</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="callback-form contact-us">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="section-heading">
                  <h2>Send us a <em>Message</em></h2>
                  <span>If you have any enquiry, please do not hesitate to contact us. Leave us a message and we will get back to you shortly.</span>
                </div>
              </div>
              <div className="col-md-12">
                <div className="contact-form">
                  <form id="contact" action method="get">
                    <div className="row">
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="name" type="text" className="form-control" id="name" placeholder="Full Name" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="email" type="text" className="form-control" id="email" pattern="[^ @]*@[^ @]*" placeholder="E-Mail Address" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-4 col-md-12 col-sm-12">
                        <fieldset>
                          <input name="subject" type="text" className="form-control" id="subject" placeholder="Subject" required />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <textarea name="message" rows={6} className="form-control" id="message" placeholder="Your Message" required defaultValue={""} />
                        </fieldset>
                      </div>
                      <div className="col-lg-12">
                        <fieldset>
                          <button type="submit" id="form-submit" className="filled-button">Send Message</button>
                        </fieldset>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="map">
          {/* How to change your own map point
	1. Go to Google Maps
	2. Click on your location point
	3. Click "Share" and choose "Embed map" tab
	4. Copy only URL and paste it within the src="" field below
*/}
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1944.300695499109!2d79.90719873456888!3d12.933321605479588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x353c57b22a1db8ea!2zMTLCsDU1JzYwLjAiTiA3OcKwNTQnMjguNiJF!5e0!3m2!1sen!2sin!4v1655642542080!5m2!1sen!2sin" width="100%" height="500px" frameBorder={0} style={{border: 0}} allowFullScreen />
        </div>
      </div>
    )
}

export default Contactus;